<template>
  <div class="widget-layout">
    <div class="widget-layout__inner">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetLayout',
};
</script>

<style scoped>
.widget-layout {
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: #f3f4f6;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.widget-layout__inner {
  width: 100%;
  max-width: 1080px;
  padding: 24px 16px;
  box-sizing: border-box;
}
</style>
